export default class FormObject {

	constructor () {
		this.loading = false
		this.error = ''
	}
}



// WEBPACK FOOTER //
// ./src/classes/api/FormObject.js